import React from 'react';
import { ArrowRight, Check } from 'lucide-react';

const CTA = ({ language }) => {
  const texts = {
    en: {
      title: 'Ready for Loovafit?',
      subtitle: 'Get access to games. Enter your number and reply with JA. Get started in seconds.',
      cta: 'Get started',
      points: ['CHF 10 per week (2 SMS Salt, 1 SMS Sunrise)', 'Opt out: send STOP YES to 804', 'Hotline +41 44 581 61 61 · gomobee.ch@silverlines.info'],
    },
    de: {
      title: 'Bereit für Loovafit?',
      subtitle: 'Zugang zu Spielen. Nummer eingeben und mit JA antworten. In wenigen Sekunden starten.',
      cta: 'Jetzt starten',
      points: ['CHF 10 pro Woche (2 SMS Salt, 1 SMS Sunrise)', 'Abo beenden: STOP YES an 804 senden', 'Hotline +41 44 581 61 61 · gomobee.ch@silverlines.info'],
    },
  };

  const t = texts[language];

  return (
    <section id="section-5" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <div className="rounded-3xl bg-gradient-to-br from-brand-600 to-brand-800 p-10 sm:p-14 border border-brand-500/20">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-4">
            {t.title}
          </h2>
          <p className="text-brand-100 text-lg mb-8 max-w-xl mx-auto">
            {t.subtitle}
          </p>
          <a
            href="/s"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-white text-brand-600 font-semibold hover:bg-brand-50 transition-colors"
          >
            {t.cta}
            <ArrowRight className="w-5 h-5" />
          </a>
          <ul className="mt-10 flex flex-col sm:flex-row flex-wrap justify-center gap-4 text-brand-100 text-sm">
            {t.points.map((point, i) => (
              <li key={i} className="flex items-center justify-center gap-2">
                <Check className="w-4 h-4 text-brand-300 flex-shrink-0" />
                {point}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CTA;
